<div class="route-page-container" *ngIf="!loading">
  <app-section>
    <app-title-background
      [title]="[routeDto.titleRu, routeDto.titleEn]"
      [map]="true"
      [locationDto]="routeDto"
      [mapSection]="true"
    />
  </app-section>
  <app-section>
    <div class="route-running-line">
      <app-running-line
        [otherText]="true"
        [text]="runningText"
      />
    </div>
    <app-looped-slider
      *ngIf="!loadingSlider && !isMobile"
      [cards]="sliderCards"
      [grid]="grid"
    />
  </app-section>
  <div *ngIf="routeDto.url !== 'antarctic-ultimate-expedition' && points.length > 0 && hotelCards.length > 0">
    <div *ngFor="let point of points">
        <app-main-busy-bee class="route-page-line-height"
                           [cards]="point.cards ?? []"
                           [texts]="[
      {text: [point.titleRu ?? '', point.titleEn ?? '']},
      ]"
                           [daysTitle]="true"
                           [grid]="1"
        />
    </div>
  </div>
  <div *ngIf="(routeDto.url === 'antarctic-ultimate-expedition' && antPoints.length > 0) || hotelCards.length === 0">
    <div *ngFor="let point of antPoints">
      <app-section>
        <app-main-busy-bee class="route-page-line-height"
                           [cards]="point.cards ?? []"
                           [texts]="[
      {text: [point.titleRu ?? '', point.titleEn ?? '']},
      ]"
                           [daysTitle]="true"
                           [grid]="1"
        />
      </app-section>
    </div>
  </div>
  <div
    class="sticky-section-wrapper"
    *ngIf="hotelCards.length > 0 && routeDto.url !== 'antarctic-ultimate-expedition'"
    [style]="getHeight('double')">
    <app-section class="sticky-section" [ngStyle]="getHeight('one')"
    >
      <app-main-best-hotels
        [texts]="[
    {text: ['Рекомендуемые ', 'Finest '], fontFamily: 'pd', fontStyle: 'italic'},
    {text: ['отели', 'Hotels']}
  ]"
        [search]="true"
        [subtitle]="true"
        [cards]="hotelCards"
        [main]="false"
        [type]="'continent'"
        [typeContent]="typeContent"
        (heightChange)="setHeight($event)"
      />
    </app-section>
  </div>
  <div
    class="sticky-section-wrapper"
    *ngIf="routeDto.url === 'antarctic-ultimate-expedition' || hotelCards.length === 0"
    [style]="getHeight('double')">
    <app-section class="sticky-section" [ngStyle]="getHeight('one')"
    >
      <app-main-busy-bee class="route-page-line-height"
                         *ngIf="lastPoint != null"
                         [cards]="lastPoint.cards ?? []"
                         [texts]="[
      {text: [lastPoint.titleRu ?? '', lastPoint.titleEn ?? '']},
      ]"
                         [daysTitle]="true"
                         [grid]="1"
      />
    </app-section>
  </div>
  <app-section-scroller class="overlapping-content" [style]="getHeight('margin')">
    <app-main-destinations (ClickOnActive)="goToDestination($event)" (loadingEmit)="loadCircle($event)"/>
  </app-section-scroller>
</div >
<app-admin-preview [adminDisplay]="adminDisplay" [uncorrectedUrl]="uncorrectedUrl" [displayPageFalse]="displayPageFalse"/>
